import { Campaign } from '@/client/campaigns';
import { formatDate } from '@/utils/date/date.helper';

const formatBannerDate = (date?: Date) =>
  formatDate(date, 'MMM D')?.toLowerCase();

export const getClickRate = (campaign: Campaign): number => {
  const { total = 0, clickedLinks = 0 } = campaign.summary ?? {};
  if (!total) return 0;
  return Math.round((clickedLinks / total) * 100);
};

export const getSubmissionRate = (campaign: Campaign): number => {
  const { total = 0, submittedData = 0 } = campaign.summary ?? {};
  if (!total) return 0;
  return Math.round((submittedData / total) * 100);
};

export const getReportRate = (campaign: Campaign): number => {
  const { total = 0, emailsReported = 0 } = campaign.summary ?? {};
  if (!total) return 0;
  return Math.round((emailsReported / total) * 100);
};

export const getCampaignRangeDate = (campaign: Campaign): string => {
  const startTime = formatBannerDate(campaign.launchDate);
  const endTime = formatBannerDate(
    campaign.sendByDate || campaign.completeAfter || campaign.completedDate,
  );
  return startTime + (endTime ? ' - ' + endTime : '');
};
